import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01f22352"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "address-form" }
const _hoisted_2 = { class: "address-form__title" }
const _hoisted_3 = { class: "address-form__content" }
const _hoisted_4 = { class: "mo-form-group mo-form-group--line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "address-form__name-wrapper" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Название адреса"),
  /*#__PURE__*/_createElementVNode("div", { class: "address-form__description" }, "например, «Дом» или «Работа»")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Адрес", -1))
const _hoisted_7 = {
  key: 0,
  class: "mo-form-group__error error"
}
const _hoisted_8 = { class: "building-data" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Дом", -1))
const _hoisted_10 = {
  key: 0,
  class: "mo-form-group__error error"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Квартира / Офис", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Подъезд", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Этаж", -1))
const _hoisted_14 = { class: "address-form__intercom" }
const _hoisted_15 = {
  for: "`intercom-${deliveryAddress.id}`",
  class: "checkbox"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox__label" }, "Есть домофон", -1))
const _hoisted_17 = { class: "address-form__controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSelect = _resolveComponent("VueSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
          type: "text",
          class: _normalizeClass({
            'base-input': true,
            'base-input--black': true,
          })
        }, null, 512), [
          [_vModelText, _ctx.name]
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["mo-form-group mo-form-group--line mo-form-group--required", {
          'mo-form-group--error': _ctx.errors.selectedAddress,
        }])
      }, [
        _hoisted_6,
        _createVNode(_component_VueSelect, {
          modelValue: _ctx.selectedAddress,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAddress) = $event)),
          options: _ctx.addresses,
          filterable: false,
          label: "fullName",
          onSearch: _ctx.debouncedFetchAddresses
        }, {
          "no-options": _withCtx(() => [
            _createTextVNode(" Похожих адресов не найдено ")
          ]),
          _: 1
        }, 8, ["modelValue", "options", "onSearch"]),
        (_ctx.errors.selectedAddress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errors.selectedAddress), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(["mo-form-group mo-form-group--block mo-form-group--required", {
            'mo-form-group--error': _ctx.errors.building,
          }])
        }, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.building) = $event)),
            type: "text",
            class: _normalizeClass({
              'base-input': true,
              'base-input--black': true,
            })
          }, null, 512), [
            [_vModelText, _ctx.building]
          ]),
          (_ctx.errors.building)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errors.building), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["mo-form-group mo-form-group--block", {
            'mo-form-group--error': _ctx.errors.flat,
          }])
        }, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.flat) = $event)),
            class: _normalizeClass({
              'base-input': true,
              'base-input--black': true,
            }),
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.flat]
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["mo-form-group mo-form-group--block", {
            'mo-form-group--error': _ctx.errors.entrance,
          }])
        }, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.entrance) = $event)),
            class: _normalizeClass({
              'base-input': true,
              'base-input--black': true,
            }),
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.entrance]
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.errors.entrance), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["mo-form-group mo-form-group--block", {
            'mo-form-group--error': _ctx.errors.floor,
          }])
        }, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.floor) = $event)),
            class: _normalizeClass({
              'base-input': true,
              'base-input--black': true,
            }),
            type: "text"
          }, null, 512), [
            [_vModelText, _ctx.floor]
          ])
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            id: "`intercom-${deliveryAddress.id}`",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isIntercomAvailable) = $event)),
            class: "checkbox__input",
            type: "checkbox",
            name: "`intercom-${deliveryAddress.id}`"
          }, null, 512), [
            [_vModelCheckbox, _ctx.isIntercomAvailable]
          ]),
          _hoisted_16
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (!_ctx.isNew)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "base-btn base-btn--default",
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
            }, " Удалить "))
          : _createCommentVNode("", true),
        (_ctx.canClose)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "base-btn base-btn--default",
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
            }, " Отменить "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["base-btn base-btn--default", {
            'base-btn--disabled': !_ctx.meta.valid,
          }]),
          type: "button",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, " Сохранить ", 2)
      ])
    ])
  ]))
}